import { render, staticRenderFns } from "./AdminInactive2025List.vue?vue&type=template&id=b32111ec&scoped=true"
import script from "./AdminInactive2025List.vue?vue&type=script&lang=js"
export * from "./AdminInactive2025List.vue?vue&type=script&lang=js"
import style0 from "./AdminInactive2025List.vue?vue&type=style&index=0&id=b32111ec&prod&lang=scss&scoped=true"
import style1 from "./AdminInactive2025List.vue?vue&type=style&index=1&id=b32111ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32111ec",
  null
  
)

export default component.exports